import {MediaItemDto} from './media-item.dto';
import {SongDto} from './song.dto';

export class PlaylistDto extends MediaItemDto {
  constructor(id?, name?, artist?, img?, public tracks: SongDto[] = []) {
    super(id, name, artist, img);
  }
}
